import useEventSettings from './index';

export const useNormalisedFilters = (eventUniqueName: string) => {
    const { data } = useEventSettings(eventUniqueName);
    return data?.filters?.reduce((acc, filter) => {
        const normalisedTags = filter.tags.reduce((accTags, currentTag) => {
            accTags[currentTag.id] = currentTag;
            return accTags;
        }, {});

        acc[filter.id] = {
            ...filter,
            tags: normalisedTags,
        };
        return acc;
    }, {});
};
